export default __webpack_public_path__ + "static/media/valance.d875a6e3.jpg";